import { SyntheticEvent } from 'react';
import { Typography } from '../../base/index';
import './index.style.scss';

// export type ChipButtonType = 'review' | 'start';

interface IChipProps {
  isCompleted: boolean;
  isContinue: boolean;
  onClick?: (event: SyntheticEvent) => void;
}

const ChipButton = (props: IChipProps) => {
  const { isCompleted, onClick } = props;
  return (
    <div onClick={onClick} className={`buttonContainer-${isCompleted} ${props.isContinue?'continue':''}` } aria-hidden>
      <Typography className={`typographyContainer`}>{props.isContinue? 'Continue': isCompleted ? 'Review' : 'Start'}</Typography>
    </div>
  );
};

export default ChipButton;
